import React from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import {
    toggleSupport,
} from '../../../redux/main/main.actions';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import ModalSupport from '../../../components/Modals/ModalFeedback/ModalFeedback';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import '../MainApp.scss';
import './SupportFeedback.scss';

const SupportFeedback = () => {
    document.title = 'Support & Feedback | DB Design';

    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (type) => {
        dispatch(toggleSupport(type, 'main'));
    };

    return (
        <div className="dash-container support-page">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}
                <ModalSupport />

                <Header title='Support & Feedback'>
                    {/* <button className='dash-main-header-button secondary'>
                        Feature Request
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9L12 15L18 9"></path></svg>
                    </button> */}

                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick('feedback'); }}>Feedback</button> */}
                </Header>

                <div className="elements-group">
                    <button className="element" onClick={(e) => { handleClick('support'); }}>
                        <div className="element-title">Support</div>
                        <div className="element-description">If you need assistance with any feature</div>
                        <div className="element-button">Request</div>
                    </button>

                    <button className="element" onClick={(e) => { handleClick('feedback'); }}>
                        <div className="element-title">Feedback</div>
                        <div className="element-description">If you’d like to share your thoughts</div>
                        <div className="element-button">Share</div>
                    </button>

                    <button className="element" onClick={(e) => { handleClick('feature'); }}>
                        <div className="element-title">Feature Request</div>
                        <div className="element-description">If you have an idea for a new feature</div>
                        <div className="element-button">Request</div>
                    </button>

                    <button className="element" onClick={(e) => { handleClick('report'); }}>
                        <div className="element-title">Report Issue</div>
                        <div className="element-description">If something’s not working right</div>
                        <div className="element-button">Report</div>
                    </button>
                </div>

            </div>
        </div>
    );
};

export default SupportFeedback;
